import { FSCollections } from '@src/constants/database';
import { API_OPERATIONS } from '@src/util/cloud-functions/operations';

import { DASHBOARDS_FORMS } from '../../../constants';
import { getCounterActionButtons } from '../actionButtons/counterActionButtons';
import { renderCounterContent } from '../renderers/counterRenderer';
import { transformCounterData } from '../transformers/counterTransformer';

import type { WidgetConfig } from './types';

export const counterConfig: WidgetConfig = {
  collectionName: FSCollections.COUNTER_CHARTS,
  componentType: DASHBOARDS_FORMS.SCHEDULE_COMPLIANCE_SUMMARY,
  op: API_OPERATIONS.SCHEDULES_COMPLETION,

  buildParams: (queryParams, commonParams) => ({
    ...commonParams,
    userIds: queryParams?.userIds,
    type: queryParams?.type,
    valueType: queryParams?.valueType,
    scheduleIds: queryParams?.scheduleIds,
    divisionIds: queryParams?.divisionIds,
    templateIds: queryParams?.templateIds,
  }),
  transformData: transformCounterData,
  renderContent: renderCounterContent,
  getActionButtons: getCounterActionButtons,
};
